import * as React from 'react';

const LegacyProductDiscountPromoBannerWrapper = () => {
  return <div>LegacyProductDiscountPromoBannerWrapper</div>;
};

export default LegacyProductDiscountPromoBannerWrapper;
